import { FilterInput, Maybe } from '@kinetic-ui/data-layer';
import { isNonNull } from 'kineticUtils';
import { useCallback, useMemo } from 'react';
import { TransformConfig, TransformFactory } from '../transforms';

export const useToFilters = ({
  transforms,
}: {
  transforms: Record<
    string,
    {
      transformConfig?: TransformConfig<any, any> | undefined;
      transformer: TransformFactory;
    }
  >;
}) => {
  const factories = useMemo(() => {
    return Object.values(transforms).map(({ transformer }) => transformer);
  }, [transforms]);

  return useCallback(
    (values: any) => {
      const filterInputs = factories.reduce((acc, { toFilter }) => {
        return [...acc, ...toFilter(values)];
      }, [] as Maybe<FilterInput>[]);

      return filterInputs.filter(isNonNull);
    },
    [factories]
  );
};
